import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
} from 'react';

export interface ExtraAnswer {
  code: string;
  activity: string;
}

interface ExtraQuestionsDataContextProps {
  extraAnswers: ExtraAnswer[];
  setExtraAnswers: React.Dispatch<React.SetStateAction<ExtraAnswer[]>>;
}

const ExtraQuestionsDataContext = createContext<
  ExtraQuestionsDataContextProps | undefined
>(undefined);

export const ExtraQuestionsDataProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [extraAnswers, setExtraAnswers] = useState<ExtraAnswer[]>([]);

  // Carrega os dados do sessionStorage no primeiro render
  useEffect(() => {
    const storedData = sessionStorage.getItem('extraQuestionsData');
    if (storedData) {
      const parsedData: ExtraAnswer[] = JSON.parse(storedData);
      setExtraAnswers(parsedData);
    }
  }, []);

  // Salva os dados no sessionStorage sempre que houver mudanças
  useEffect(() => {
    sessionStorage.setItem('extraQuestionsData', JSON.stringify(extraAnswers));
  }, [extraAnswers]);

  const contextValue = useMemo(
    () => ({
      extraAnswers,
      setExtraAnswers,
    }),
    [extraAnswers],
  );

  return (
    <ExtraQuestionsDataContext.Provider value={contextValue}>
      {children}
    </ExtraQuestionsDataContext.Provider>
  );
};

export const useExtraQuestionsData = () => {
  const context = useContext(ExtraQuestionsDataContext);
  if (!context) {
    throw new Error(
      'useExtraQuestionsData deve ser usado dentro de um ExtraQuestionsDataProvider',
    );
  }
  return context;
};
